export default "__VITE_ASSET__C2wm6Hjj__"